import { StatsigUser } from '@statsig/react-bindings';

export const createStatSigUser = (
  deviceId: string,
  dpSellerId?: number | null,
  dpEnquiryId?: number | null,
): StatsigUser => ({
  customIDs: {
    'Device Cookie ID': deviceId,
    'DP Enquiry ID': dpEnquiryId?.toString() ?? '',
    'DP Seller ID': dpSellerId?.toString() ?? '',
  },
  userID: deviceId,
});
